import React, { PropTypes } from 'react'
import { Link } from 'react-router'

import './ServicesNavbar.scss'
import * as paths from 'utils/paths'

const ServicesNavbar = ({userId, user}) => {
  if(user.addresses.length == 0){
    return (
      <div className='ServicesNavbar'>
        <Link
          to={paths.userNextServices(userId)}
          className='ServicesNavbar-link'
          activeClassName='ServicesNavbar-link--active'
          >
          Próximos servicios
        </Link>

        <a
          href={paths.userPreviousServices(userId, 'historial')}
          className='ServicesNavbar-link'
          >
          Historial
        </a>

        <button>
          <Link
            href={willkomen_root}
            className='ServicesNavbar-link ServicesNavbar-newService'
          ><span className='icon-add_circle' /> Crear nuevo servicio
          </Link>
        </button>

        {/* <button
          onClick={()=>{ alert('No tienes registrada una dirección.\nContacta al equipo de soporte.')}}
          className='ServicesNavbar-link ServicesNavbar-newService'
          >
          <span className='icon-add_circle' /> Crear nuevo servicio
        </button> */}
      </div>
    )
  }else{
    const { latitude, longitude } = user.addresses[0].coordinates;
    const { street, colony }      = user.addresses[0];

    return (
      <div className='ServicesNavbar'>
        <Link
          to={paths.userNextServices(userId)}
          className='ServicesNavbar-link'
          activeClassName='ServicesNavbar-link--active'
          >
          Próximos servicios
        </Link>

        <a
          href={paths.userPreviousServices(userId, 'historial')}
          className='ServicesNavbar-link'
          >
          Historial
        </a>
        <Link
          href={paths.onboarding(latitude, longitude, userId, street, colony)}
          className='ServicesNavbar-link ServicesNavbar-newService'
          >
          <span className='icon-add_circle' /> Crear nuevo servicio
        </Link>
      </div>
    )
  }
}

ServicesNavbar.displayName = 'ServicesNavbar'
ServicesNavbar.propTypes = {
  userId: PropTypes.string.isRequired
}
ServicesNavbar.defaultProps = {}

export default ServicesNavbar



// WEBPACK FOOTER //
// ./src/screens/App/screens/UserProfile/screens/UserServices/components/ServicesNavbar/ServicesNavbar.js